import React from 'react';
import Hero from '../components/Hero';
import Products from '../components/Products';

const Home: React.FC = () => {
  return (
    <>
      <Hero />
      <Products />
    </>
  );
};

export default Home;
